// extracted by mini-css-extract-plugin
export default {"page":"About_page__tt46X"};